const isBrowser = typeof window !== "undefined";

export const env = {
  REACT_APP_BACKEND_URL:
    (isBrowser && window.__ENV__?.REACT_APP_BACKEND_URL) ||
    process.env.REACT_APP_BACKEND_URL,

  REACT_APP_API_URL:
    (isBrowser && window.__ENV__?.REACT_APP_API_URL) ||
    process.env.REACT_APP_API_URL,

  REACT_APP_STT_WEBSOCKET_URL:
    (isBrowser && window.__ENV__?.REACT_APP_STT_WEBSOCKET_URL) ||
    process.env.REACT_APP_STT_WEBSOCKET_URL,

  REACT_APP_POSTHOG_KEY:
    (isBrowser && window.__ENV__?.REACT_APP_POSTHOG_KEY) ||
    process.env.REACT_APP_POSTHOG_KEY,

  REACT_APP_POSTHOG_HOST:
    (isBrowser && window.__ENV__?.REACT_APP_POSTHOG_HOST) ||
    process.env.REACT_APP_POSTHOG_HOST,

  NODE_ENV:
    (isBrowser && window.__ENV__?.NODE_ENV) ||
    process.env.NODE_ENV ||
    "development",

  IS_MAINTENANCE:
    (isBrowser && window.__ENV__?.REACT_APP_IS_MAINTENANCE) ||
    process.env.REACT_APP_IS_MAINTENANCE ||
    'false',
};